// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/resource-workload-management.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/resource-workload-management/resource-workload-management.js';

mount([g0]);
